import CrudRequest from 'Domain/CrudRequest';
import HttpService from 'Support/services/HttpService';

export default class LoansRequest extends CrudRequest {
  static baseUrl() {
    return '/v1/emprestimos/consultarTodosOsEmprestimos';
  }

  static manuallyTerminateList(query = {}) {
    return HttpService.get('/v1/relatorios/relatorioDeEmprestimosMoney', {
      params: query,
    });
  }

  static terminate(params = {}) {
    return HttpService.get('/v1/relatorios/relatorioDeEmprestimosMoney/agendar', {
      params,
    });
  }

  static getBoletos(id) {
    return HttpService.get(`/v1/emprestimos/boletos/${id}`);
  }
}
